import React from 'react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import './index.css';

// Configurar la barra de estado para Android
if (Capacitor.isNativePlatform()) {
  StatusBar.setBackgroundColor({ color: '#1a1a1a' });
  StatusBar.setStyle({ style: Style.Dark });
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('No se encontró el elemento root');
}

// Ocultar el splash screen inmediatamente cuando la aplicación se monte
const hideSplash = async () => {
  if (Capacitor.isNativePlatform()) {
    try {
      // Forzar la ocultación del splash screen
      await SplashScreen.hide({ fadeOutDuration: 0 });
      console.log('SplashScreen ocultado correctamente');
    } catch (e) {
      console.warn('Error al ocultar el splash screen:', e);
    }
  }
};

// Ocultar el splash screen antes de que se monte la aplicación
hideSplash().catch(console.error);

const root = createRoot(container);
root.render(
  <StrictMode>
    <App onAppReady={hideSplash} />
  </StrictMode>
);

// Ocultar el splash screen después de 3 segundos como respaldo
setTimeout(hideSplash, 3000);
